<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.reasons', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mReason.reference }}
                        </h3>
                    </div>
        <b-container>
            <div class="list-group list-group-flush">
                <b-row>
                    <b-col col sm="12">
                        <div class="list-group-item">
                            {{ $t('message.reference') }}:

                            <span class="font-weight-bold">
                                {{ mReason.reference }}
                            </span>
                        </div>
                    </b-col>
                    <b-col col sm="12">
                        <div class="list-group-item">
                            {{ $tc('message.description', 1) }}:

                            <span class="font-weight-bold">
                                {{ mReason.description }}
                            </span>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="justify-content-center">
                    <div class="card-footer text-right" v-if="mReason.isAuthor || hasAdminRole">
                        <b-button variant="primary" @click="updateReason">
                            {{ $t('message.edit') }}
                        </b-button>

                        <b-button v-b-modal.delete-modal variant="danger">
                            {{ $t('message.delete') }}
                        </b-button>
                    </div>
                </b-row>
            </div>
        </b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.reasons', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mReason.reference }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteReason">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    
    export default {
        name: "Reason",

        computed: {
            ...mapGetters(["reason","hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            mReason: function() {
                return this.reason;
            }
        },

        data() {
            return {
                reason_slug: this.$route.params.reason
            }
        },

        methods: {
            getReason() {
                let args = {
                    motif: this.reason_slug
                };

                this.$store.dispatch("getReason", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateReason() {
                this.$router.push({ name: 'edit-reason', params: { motif: this.reason_slug } });
            },

            deleteReason() {
                let self = this;
                let args = {
                    motif: this.reason_slug
                };

                let successMessage = this.$i18n.t('message.reasonDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteReason', { args, index: self.reason_slug, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getReason();
        }
    }
</script>

<style scoped>

</style>